import React from "react";
import PropTypes from 'prop-types';
import {uid} from "react-uid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import {ItemSources} from "../ToolBarUtils/ItemSources";
import DragComponent from "./DragComponent";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    dragGroupComponents: {
        margin: '0 10px',
    },
    dragGroup: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap'
    }
}));

const DragGroup = ({group}) => {
    const classes = useStyles();
    return (
        <div>
            <Typography
                color={"textSecondary"}
                style={{
                    background: "rgba(0,0,0,.03)",
                    marginTop: 5
                }}>
                {group.label}
            </Typography>
            <Divider/>
            <div className={classes.dragGroup}>
                {group.components.map(component => {
                    const itemIndex = ItemSources.findIndex(i => i.type === component.id);
                    const item = ItemSources[itemIndex];
                    return (
                        <DragComponent
                            key={uid(JSON.stringify(item))}
                            source={item.source}
                            label={item.label}
                            icon={item.icon}
                            type={item.type}
                        />
                    )
                })}
            </div>
        </div>
    )
};
export default DragGroup;

DragGroup.propTypes = {
    group: PropTypes.object
};